const MAX_DIMENSION = 1920;
const COMPRESSION_QUALITY = 0.8;
const OUTPUT_MIME = "image/jpeg";

/**
 * Compresses a feedback image using the Canvas API.
 * Resizes to at most 1920 px on the longest side and re-encodes as JPEG at 80% quality.
 * Falls back to the original file if anything goes wrong (no canvas context, load error, etc.).
 */
const compressFeedbackImage = (file: File): Promise<File> =>
  new Promise((resolve) => {
    const img = new Image();
    const objectUrl = URL.createObjectURL(file);

    img.onload = () => {
      URL.revokeObjectURL(objectUrl);

      let { width, height } = img;
      if (width > MAX_DIMENSION || height > MAX_DIMENSION) {
        if (width >= height) {
          height = Math.round((height * MAX_DIMENSION) / width);
          width = MAX_DIMENSION;
        } else {
          width = Math.round((width * MAX_DIMENSION) / height);
          height = MAX_DIMENSION;
        }
      }

      const canvas = document.createElement("canvas");
      canvas.width = width;
      canvas.height = height;

      const ctx = canvas.getContext("2d");
      if (!ctx) {
        resolve(file);
        return;
      }

      ctx.drawImage(img, 0, 0, width, height);

      canvas.toBlob(
        (blob) => {
          if (!blob) {
            resolve(file);
            return;
          }
          const outputName = file.name.replace(/\.[^.]+$/, ".jpg");
          resolve(
            new File([blob], outputName, {
              type: OUTPUT_MIME,
              lastModified: Date.now()
            })
          );
        },
        OUTPUT_MIME,
        COMPRESSION_QUALITY
      );
    };

    img.onerror = () => {
      URL.revokeObjectURL(objectUrl);
      resolve(file);
    };

    img.src = objectUrl;
  });

export { compressFeedbackImage };
